import { Button, styled, ToggleButtonGroup, Toolbar } from "@mui/material";

export const MobileToolbar = styled(Toolbar)({
  justifyContent: "space-between",
  gap: 1
});

export const MobileButton = styled(Button)({
  minHeight: 48
});

export const MobileToggleButtonGroup = styled(ToggleButtonGroup)({
  "& .MuiToggleButton-root": {
    minHeight: 48,
    minWidth: 48
  }
});
